module.exports = __webpack_public_path__ + "assets/img/detail-img1-00d219a9.png";